// extracted by mini-css-extract-plugin
export default {"Plan":"EledoPricingPlan_Plan__SatSM","PlanTitle":"EledoPricingPlan_PlanTitle__ztsuk","PlanLine":"EledoPricingPlan_PlanLine__jFO+a"};